import { render, staticRenderFns } from "./Datapoint.vue?vue&type=template&id=f75ee9b4"
import script from "./Datapoint.vue?vue&type=script&lang=js"
export * from "./Datapoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports